import { render, staticRenderFns } from "./CustomerDietitianAppointmentList.vue?vue&type=template&id=b8e82ba8&scoped=true&"
import script from "./CustomerDietitianAppointmentList.vue?vue&type=script&lang=js&"
export * from "./CustomerDietitianAppointmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e82ba8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDataTable,VIcon,VLayout})
